import { Observable, Subscription } from 'rxjs';

import { CatsActionModeEnum, CatsRecordTypeEnum } from '@shared-enums/cats.enum';
import { trimDecimalZeros } from '@shared-helpers/string-number-helpers';

import { ICatRecord } from '../../interfaces/incoming';
import { CatsDb } from '../catsDB';

export class ProductionGroupQuantity {
  private requestInFlight: Subscription;

  constructor(
    public Employeenumber: string,
    public Workdate: string,
    public Quantity: string,
    public ZempCreatedBy: string,
    public RecOrder: string,
    public Zmatnr: string,
    public Extdocumentno: string,
    public Statkeyfig: string,
    public ZprdGrpID: string,
    public Counter: string,
  ) {}

  public handleChange(catsDbInstance: CatsDb) {
    let action$: Observable<ICatRecord>;
    if (this.requestInFlight != null && !this.requestInFlight.closed) {
      this.requestInFlight.unsubscribe();
    }
    if (this.Counter) {
      action$ = this.updateSelf$(catsDbInstance);
      if (!this.Quantity) {
        this.Counter = undefined;
      }
    } else {
      action$ = this.createSelf$(catsDbInstance);
    }

    this.requestInFlight = action$.subscribe({
      next: (x) => {
        if (x) this.Counter = x.Counter;
      },
      error: (err) => {
        console.error('Error in ProductionGroupQuantity:', err);
      },
    });
  }

  private updateSelf$(catsDbInstance: CatsDb): Observable<ICatRecord> {
    const data: Partial<ICatRecord> = {
      Quantity: trimDecimalZeros(this.Quantity ?? '0'),
      Quantity_X: true,
      Counter: this.Counter,
    };
    return catsDbInstance.simpleSingleCats$(CatsActionModeEnum.Update, data);
  }

  private createSelf$(catsDbInstance: CatsDb): Observable<ICatRecord> {
    const data: Partial<ICatRecord> = {
      Employeenumber: this.Employeenumber,
      Workdate: this.Workdate,
      Quantity: trimDecimalZeros(this.Quantity ?? '0'),
      ZempCreatedBy: this.ZempCreatedBy,
      RecOrder: this.RecOrder,
      Zmatnr: this.Zmatnr,
      Extdocumentno: this.Extdocumentno,
      Statkeyfig: this.Statkeyfig,
      ZprdGrpID: this.ZprdGrpID,
      Zrecordtype: CatsRecordTypeEnum.ProductionQuantity,
    };
    return catsDbInstance.simpleSingleCats$(CatsActionModeEnum.Insert, data);
  }
}
